import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { RefactorRequest } from '../../../core/models/refactor-request';
import { SubmitTaskResponse } from '../../../core/models/submit-task-response';
import { ProjectAnalysisReport } from '../../../core/models/analysis-report';

@Injectable({ providedIn: 'root' })
export class AnalysisService {

  private readonly apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.refactorApiUrl;
  }

  analyzeProject(token: string, request: RefactorRequest): Observable<SubmitTaskResponse> {
    const headers = new HttpHeaders({
      'X-Genai-Bearer': token,
      'Content-Type': 'application/json',
    });
    return this.http.post<SubmitTaskResponse>(
      `${this.apiUrl}/analysis/project`, request, { headers }
    );
  }

  analyzeIndividualFiles(token: string, fileIds: string[], request: RefactorRequest): Observable<SubmitTaskResponse> {
    const headers = new HttpHeaders({
      'X-Genai-Bearer': token,
      'Content-Type': 'application/json',
    });
    const body = { ...request, fileIds };
    return this.http.post<SubmitTaskResponse>(
      `${this.apiUrl}/analysis/individual-files`, body, { headers }
    );
  }

  getAnalysisResult(taskId: string): Observable<ProjectAnalysisReport> {
    return this.http.get<ProjectAnalysisReport>(
      `${this.apiUrl}/analysis/tasks/${taskId}/result`
    );
  }

  stop(taskId: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}/analysis/stop`, { taskId });
  }
}
